import type { PricingVersionTuple } from '../../model/model.ts'

import type { FrAupaPricingVersionFormat } from './model.ts'

export const frAupaPricingVersions = [
  ['pricing-fr-aup-axa-1.0.0-2026-09-08', { label: 'Version 1' }],
  ['pricing-fr-aup-axa-1.0.1-2027-01-01', { label: 'Version 1.0.1 - Terrorism tax €8.50' }],
] as const satisfies PricingVersionTuple<FrAupaPricingVersionFormat>[]

export type FrAupaPricingVersion = (typeof frAupaPricingVersions)[number][0]
